<template>
    <div class="w100p">
        <v-text-field 
	        append-icon="attach_file" 
	        single-line
	        v-model="filename" 
	        :label="label" 
	        :required="required"
	        :disabled="disabled"
	        ref="fileTextField"
            readonly
            :persistent-hint="persistent_hint"
            :hint="hint"
        ></v-text-field>
        <input 
	        type="file" 
	        :accept="accept" 
	        :multiple="multiple" 
	        :disabled="disabled"
	        ref="fileInput" 
	        @change="onFileChange"
	    >
        <v-btn class="ml-0" small raised @click="onPickFile" v-if="!imageUrl">
            Seleziona
        </v-btn>
        <div v-else class="flex">
            <img v-if="showPreview"
                :src="imageUrl"
                ref="imageUrl"
                height="100"
                max-width="250"
                class="cursor-pointer mr25i"
                @click="openFile"
            >
            <div class="margin-auto ml0i">

                <v-btn small raised class="error ml0i" @click="removeFile">
                    Rimuovi
                </v-btn>
            </div>
        </div>
    </div>
</template>
<script>
export default {
	name: 'input-file',
	props: {
		value: {
			type: [Object]
		},
		accept: {
			type: String,
			default: '*'
		},
		label: {
			type: String,
			default: 'Please choose...'
		},
		required: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		persistent_hint: {
			type: Boolean,
			default: false
		},
		hint: {
			type: String,
			default: ''
		},
		multiple: {
			type: Boolean, // not yet possible because of data
			default: false
		},
		showPreview: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			filename: '',
			imageUrl: ''
		}
	},

	watch: {
		value(f) {
			this.filename = f.original_file_name
			this.imageUrl = f.path_api
		}
	},

	mounted() {
		if (this.value) {
			this.filename = this.value.original_file_name
			this.imageUrl = this.value.path_api
		}
	},

	methods: {
		onPickFile() {
			this.$refs.fileInput.click()
		},

		getFormData(files) {
			const data = new FormData()
			for (let file of files) {
				data.append('files[]', file, file.name)
			}
			return data
		},

		onFocus() {
			if (!this.disabled) {
				this.$refs.fileInput.click()
			}
		},

		onFileChange($event) {
			const files = $event.target.files || $event.dataTransfer.files
			const form = this.getFormData(files)
			if (files) {
				if (files.length > 0) {
					this.filename = [...files].map(file => file.name).join(', ')
				} else {
					this.filename = null
				}

				const fileReader = new FileReader()
				fileReader.addEventListener('load', () => {
					this.imageUrl = fileReader.result
				})
				fileReader.readAsDataURL(files[0])
			} else {
				this.filename = $event.target.value.split('\\').pop()
			}
			this.$emit('input', this.filename)
			this.$emit('formData', form)
		},

		removeFile() {
			this.imageUrl = ''
			this.filename = ''
			this.$refs.fileInput.value = ''
			this.$emit('formData', null)
		},

		openFile() {
			window.open(this.imageUrl, '_blank')
		}
	}
}
</script>
<style scoped>
input[type="file"] {
  position: absolute;
  left: -99999px;
}
</style>
